import React from "react";
import PropTypes from "prop-types";

const PageContent = (props) => {
	return (
		<div>
			<section className="o-reactpage__main">
				{props.children}
			</section>
			<div className="vtt-react-datepicker-popper"></div>
		</div>
	);
};

PageContent.propTypes = {
	children: PropTypes.node.isRequired
};

export default PageContent;
